import React from 'react'
import { AlignItems, BorderStyle, Box, Color, Image, Text } from '@gousto-internal/citrus-react'
import PlaceholderImage from './StackedRecipePlaceholder.png'

export const PlaceholderBanner = function () {
  return (
    <Box
      display="flex"
      alignItems={AlignItems.Center}
      borderColor={Color.ColdGrey_200}
      borderStyle={BorderStyle.Dashed}
      borderWidth={0.5}
      flexGrow={[1, 0]}
      flexShrink={[1, 0]}
      gap={3}
      minWidth="0"
      maxWidth={['none', '300px']}
      paddingH={2}
      paddingV={1}
      width={['100%', '300px']}
      height="100%"
      data-testid="placeholderBanner"
    >
      <Image
        alt="Placeholder recipe image"
        src={PlaceholderImage}
        height="40px"
        width="unset"
        style={{ flexShrink: 0, marginBottom: '-0.3rem' }}
      />
      <Box flexGrow={1} minWidth="0">
        <Text size={2} fontWeight={700} color={Color.ColdGrey_800}>
          Add all the recipes you like
        </Text>
        <Text size={2} color={Color.ColdGrey_600}>
          Narrow down at checkout
        </Text>
      </Box>
    </Box>
  )
}
